import Entity from './entity';
import { computed } from '@ember/object';
import { hash, htmlEscape } from '@intercom/pulse/lib/computed-properties';
import Em from 'ember';
export default Entity.extend({
  precedence: 0,
  isAttribute: true,
  identifier: null,
  isEventMetadata: false,
  isSelectedEventMetadata: false,
  name: null,
  type: 'attribute',
  ignoreContentsWhenSerializing: true,
  tagName: 'ic-attribute',
  hasNonEditableContainer: true,
  hasEditor: true,
  openingHtmlForSerialized: Em.computed('escapedFallback', 'identifier', function () {
    let html = `{{${this.get('identifier')}`;
    if (this.get('escapedFallback')) {
      html += `|fallback:"${this.get('escapedFallback')}"`;
    }
    return html;
  }),
  closingHtmlForSerialized: '}}',
  classes: Em.computed('isApp', 'fallback', 'noFallback', function () {
    if (this.get('noFallback')) {
      return '';
    }
    let classes = '';
    if (!this.get('isApp')) {
      classes += 'is-hot';
      if (Em.isEmpty(this.get('fallback')) || this.get('isInvalidMetadata')) {
        classes += ' is-warning';
      }
    }
    return classes;
  }),
  escapedIndentifier: htmlEscape('identifier'),
  escapedFallback: htmlEscape('fallback'),
  isInvalidMetadata: Em.computed(function () {
    return this.get('isEventMetadata') && !this.get('isSelectedEventMetadata');
  }),
  additionalAttributes: computed('escapedIndentifier', 'escapedFallback', 'classes', function () {
    return `data-identifier="${this.escapedIndentifier}" data-fallback="${this.escapedFallback}" contenteditable="false" class="${this.classes}"`;
  }),
  attributesToCopy: ['identifier', 'fallback', 'startIndex', 'endIndex', 'name', 'noFallback', 'isApp'],
  options: hash('identifier', 'fallback', 'name'),
  isSelectedForEdit(selection) {
    let isExactRange = selection.hasPositionRange(this.get('startIndex'), this.get('endIndex'));
    if (isExactRange && selection.get('isSingleBlockAndItem')) {
      return true;
    }
    return false;
  }
});